import { render } from "./AppointmentHistory.vue?vue&type=template&id=6631aed5&scoped=true&lang=pug"
import script from "./AppointmentHistory.vue?vue&type=script&lang=js"
export * from "./AppointmentHistory.vue?vue&type=script&lang=js"

import "./AppointmentHistory.vue?vue&type=style&index=0&id=6631aed5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6631aed5"]])

export default __exports__